import { cn } from '@typedream/ui';
import { ReactNode } from 'react';
import OptionsRadio from './OptionsRadio';

function OptionsItem({
  title,
  className,
  endTitle,
  classNameEnd,
}: {
  title: string | ReactNode;
  endTitle?: string | ReactNode;
  classNameEnd?: string;
  className?: string;
}) {
  return (
    <div className="flex items-center justify-between w-full flex-1">
      <div className="flex items-center justify-start w-full flex-1 gap-2.5">
        <OptionsRadio />
        <div className={cn('flex-1 whitespace-nowrap overflow-hidden text-ellipsis', className)}>
          {title}
        </div>
      </div>
      <div className={classNameEnd}>{endTitle}</div>
    </div>
  );
}

OptionsItem.defaultProps = {
  endTitle: undefined,
  classNameEnd: undefined,
  className: undefined,
};

export default OptionsItem;
